// Components
import Typography from '@mui/material/Typography'
import AutocompleteInput from '../AutocompleteInput/AutocompleteInput'
import { ImplantReportSenderModal } from './ImplantReportSenderModal/ImplantReportSenderModal'
import { LoadingButton } from 'components/mui'
import { ViewImplantReportModal } from './ViewImplantReportModal/ViewImplantReportModal'

// Logic
import { useImplantReportSenderLogic } from './ImplantReportSender.logic'

// Types
import { ImplantReportType, Option } from 'common/types'
import { ImplantReportSenderProps } from './ImplantReportSender.types'

// Styles
import './ImplantReportSender.scss'

const NewImplantReportSender = (props: ImplantReportSenderProps) => {
  const { surgeryId, implantReportStatus, surgeryDate, provider } = props
  const logic = useImplantReportSenderLogic(props)

  return (
    <div className="implant-report-sender-container">
      <div className="implant-report-header">
        <div className="implant-header-title">
          <Typography variant="h3" sx={{ transform: 'none' }}>
            Share Surgery Report(s)
          </Typography>
        </div>

        {logic.isReportSent && (
          <LoadingButton
            fullwidth={false}
            wrapText
            onClick={() => {
              logic.setViewReportsModalOpen(true)
            }}
            disabled={!implantReportStatus || implantReportStatus.length === 0}
          >
            View Report(s)
          </LoadingButton>
        )}
      </div>

      <AutocompleteInput
        id={'implant-report-input'}
        className="implant-report-menu"
        handleChangeFormData={(e) => {
          logic.setImplantReportInputs((prevState) => ({
            ...prevState,
            reportType: e.target.value as Option,
          }))
          logic.setInputModalOpen(true)
        }}
        name={'implant-report'}
        label="Select Report Template"
        variant="outlined"
        value={logic.implantReportInputs.reportType || null}
        options={logic.reports || []}
        autoSelect={false}
        disableClearable
        isLoading={logic.isLoading}
      />

      {logic.inputModalOpen && (
        <ImplantReportSenderModal
          assetIds={logic.assetIds}
          inputModalOpen={logic.inputModalOpen}
          formatEnumValue={(value) => value}
          errorMessage={logic.errorMessage || ''}
          surgeryDate={surgeryDate}
          surgeryId={surgeryId}
          implantReportStatus={implantReportStatus || []}
          implantReportInputs={logic.implantReportInputs}
          setImplantReportInputs={logic.setImplantReportInputs}
          unformatEnumValue={(value) => {
            return value as ImplantReportType
          }}
          setErrorMessage={logic.setErrorMessage}
          setInputModalOpen={logic.setInputModalOpen}
          provider={provider}
        />
      )}

      {logic.viewReportsModalOpen && (
        <ViewImplantReportModal
          implantReportStatus={implantReportStatus || []}
          formatEnumValue={(value) => value}
          viewReportsModalOpen={logic.viewReportsModalOpen}
          setViewReportsModalOpen={logic.setViewReportsModalOpen}
        />
      )}
    </div>
  )
}

export default NewImplantReportSender
